export default[
	{
		path: '/loans/list',
		name: 'LoanList',
		component: () => import('@/Modules/LoanList/Views/LoanList.vue'),
		meta : {
			title : 'Loan List'
		}
	},
	{
		path: '/loans/gold/:id',
		name: 'GoldLoan',
		component: () => import('@/Modules/LoanList/Views/GoldLoan.vue'),
		meta : {
			title : 'Gold Loan'
		}
	},
	
	{
		path: '/loans/gold/:id/ledger',
		name: 'GoldLoanLedger',
		component: () => import('@/Modules/LoanList/Views/GoldLoanLedger.vue'),
		meta : {
			title : 'Gold Loan Ledger'
		}
	},
	
	
		{
		path: '/loans/property/:id',
		name: 'PropertyLoan',
		component: () => import('@/Modules/LoanList/Views/PropertyLoan.vue'),
		meta : {
			title : 'Property Loan'
		}
	},
	
	{
		path: '/loans/property/:id/ledger',
		name: 'PropertyLoanLedger',
		component: () => import('@/Modules/LoanList/Views/PropertyLoanLedger.vue'),
		meta : {
			title : 'Property Loan Ledger'
		}
	},
	
	{
		path: '/loans/property/:id/emi-chart',
		name: 'PropertyLoanEMI',
		component: () => import('@/Modules/LoanList/Views/PropertyLoanEmi.vue'),
		meta : {
			title : 'Property Loan EMI Chart'
		}
	},
	
	
	{
		path: '/loans/business/:id',
		name: 'BusinessLoan',
		component: () => import('@/Modules/LoanList/Views/BusinessLoan.vue'),
		meta : {
			title : 'Business Loan'
		}
	},
	
	{
		path: '/loans/business/:id/ledger',
		name: 'BusinessLoanLedger',
		component: () => import('@/Modules/LoanList/Views/BusinessLoanLedger.vue'),
		meta : {
			title : 'Business Loan Ledger'
		}
	},
	
	{
		path: '/loans/business/:id/emi-chart',
		name: 'BusinessLoanEMI',
		component: () => import('@/Modules/LoanList/Views/BusinessLoanEmi.vue'),
		meta : {
			title : 'Business Loan EMI Chart'
		}
	},
	
	{
		path: '/loans/gold-emi/:id',
		name: 'GoldEmiLoan',
		component: () => import('@/Modules/LoanList/Views/GoldEmiLoan.vue'),
		meta : {
			title : 'Gold Emi Loan'
		}
	},
	
	{
		path: '/loans/gold-emi/:id/ledger',
		name: 'GoldEmiLoanLedger',
		component: () => import('@/Modules/LoanList/Views/GoldEmiLoanLedger.vue'),
		meta : {
			title : 'Gold Emi Loan Ledger'
		}
	},
	
	
	{
		path: '/loans/gold-emi/:id/emi-chart',
		name: 'GoldEmiLoanEMI',
		component: () => import('@/Modules/LoanList/Views/GoldEmiLoanEmi.vue'),
		meta : {
			title : 'Gold Emi Loan Emi'
		}
	},
	
	{
		path: '/loans/fd/:id',
		name: 'FDLoan',
		component: () => import('@/Modules/LoanList/Views/FDLoan.vue'),
		meta : {
			title : 'FD Loan'
		}
		
	},
	
	{
		path: '/loans/fd/:id/ledger',
		name: 'FDLoanLedger',
		component: () => import('@/Modules/LoanList/Views/FDLoanLedger.vue'),
		meta : {
			title : 'FD Loan Ledger'
		}
	},
	
	{
		path: '/loans/cd/:id',
		name: 'CDLoan',
		component: () => import('@/Modules/LoanList/Views/CDLoan.vue'),
		meta : {
			title : 'CD Loan'
		}
		
	},
	
	{
		path: '/loans/cd/:id/ledger',
		name: 'CDLoanLedger',
		component: () => import('@/Modules/LoanList/Views/CDLoanLedger.vue'),
		meta : {
			title : 'CD Loan Ledger'
		}
	},
	
	
	
	
	
	
]


